import {NgModule} from "@angular/core";
import {DataTablePagination, DataTableConfig} from "./datatable.components";
import {SortingClassDirective} from "./datatable.directives";
import { FormsModule } from '@angular/forms';
import {CommonModule} from "@angular/common";

@NgModule({
    declarations: [DataTablePagination, DataTableConfig, SortingClassDirective],
    imports     : [CommonModule, FormsModule],
    exports     : [DataTablePagination, DataTableConfig, SortingClassDirective],
})

export class DataTableModule {}


// WEBPACK FOOTER //
// ./src/app/components/common/datatables/datatable.module.ts